import React from "react";
import ReactECharts from "echarts-for-react";
import ChartCard from "../ChartCard";
import { COLORS } from "../../mockData";

const TotalAssessmentsChart = ({ data, loading }) => {
  if (!data && !loading) return null;

  const categories = data?.xAxis || [];
  const phq9Series = data?.yAxis?.find((s) => s.label === "PHQ-9");
  const gad7Series = data?.yAxis?.find((s) => s.label === "GAD-7");
  const phq9 = phq9Series?.data || [];
  const gad7 = gad7Series?.data || [];

  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
    },
    legend: {
      data: ["PHQ-9", "GAD-7"],
      top: 0,
      right: 0,
      icon: "rect",
      itemWidth: 12,
      itemHeight: 12,
      textStyle: { color: COLORS.body, fontSize: 12 },
    },
    grid: {
      left: "3%",
      right: "6%",
      bottom: "12%",
      top: "12%",
      containLabel: true,
    },
    xAxis: {
      type: "value",
      axisLine: { lineStyle: { color: COLORS.border } },
      splitLine: { lineStyle: { color: COLORS.border, type: "dashed" } },
      axisLabel: { color: COLORS.body, fontSize: 11 },
      name: data?.yAxisLabel || "Number of assessments",
      nameLocation: "middle",
      nameGap: 30,
      nameTextStyle: { color: COLORS.body, fontSize: 12 },
    },
    yAxis: {
      type: "category",
      data: categories,
      axisLine: { lineStyle: { color: COLORS.border } },
      axisLabel: { color: COLORS.body, fontSize: 11 },
      inverse: true,
    },
    series: [
      {
        name: "PHQ-9",
        type: "bar",
        barWidth: 16,
        barGap: "20%",
        itemStyle: { color: COLORS.phq9, borderRadius: [0, 4, 4, 0] },
        label: {
          show: true,
          position: "insideLeft",
          color: "#ffffff",
          fontSize: 11,
          fontWeight: 600,
          offset: [4, 0],
        },
        data: phq9,
      },
      {
        name: "GAD-7",
        type: "bar",
        barWidth: 16,
        barGap: "20%",
        itemStyle: { color: COLORS.gad7, borderRadius: [0, 4, 4, 0] },
        label: {
          show: true,
          position: "insideLeft",
          color: "#ffffff",
          fontSize: 11,
          fontWeight: 600,
          offset: [4, 0],
        },
        data: gad7,
      },
    ],
  };

  const chartHeight = Math.max(320, categories.length * 60);

  return (
    <ChartCard
      title={data?.title || "Total Assessments Completed"}
      subtitle={data?.timeRange || ""}
    >
      <ReactECharts option={option} style={{ height: chartHeight }} />
    </ChartCard>
  );
};

export default TotalAssessmentsChart;
